import { USER, USER_LETTER, USER_LETTER_VALID, USER_EDIT, ENGAGEMENT_BALANCE } from '@store/types'
import { assign } from '@/helpers/object'
import request from '@queries'
import * as Sentry from '@sentry/browser'
import UserQuery from '@queries/User'
import axios from 'axios'

export const letterDataTemplate = {
  name: undefined,
  document: undefined,
  number: undefined,
  statement: false,
  email: undefined
}

const state = {
  user: {
    name: '',
    last_name: '',
    email: '',
    document: '',
    avatar: '',
    phone: '',
    // Dados fictícios
    cashback: 216,
    cashback_total: 12000,
    awards_balance: 0,
    engagement_balance: 0
  },
  letterData: { ...letterDataTemplate }
}

const getters = {
  [USER]: (_) => {
    return _.user
  },
  [USER_LETTER]: (_) => {
    const letter = assign(
      'right',
      _.user,
      _.letterData
    )

    return letter
  },

  [ENGAGEMENT_BALANCE]: (state) => state.user.engagement_balance / 100,

  [USER_LETTER_VALID]: (_, getters) => {
    const documents = getters[USER_LETTER]
    return !Object.values(documents)
      .some(_ => !_) &&
      documents.document &&
      documents.document.length === 14
  }
}

const mutations = {
  [USER]: (state, payload) => {
    state.user = { ...state.user, ...payload }
  },

  [USER_LETTER]: (state, payload) => {
    state.letterData = { ...state.letterData, ...payload }
  }
}

const actions = {
  [USER_LETTER]: ({ commit }, payload) => {
    commit(USER_LETTER, payload)
  },

  [USER]: async ({ commit }) => {
    const response = await request(UserQuery)
    const user = {
      ...response.data.data.user
    }

    commit(USER, user)
    return user
  },

  [USER_EDIT]: async ({ dispatch }, payload) => {
    try {
      Object.keys(payload)
        .forEach(key => {
          if (payload[key] === '') payload[key] = null
        })

      const response = await axios.patch('user', payload)

      dispatch(USER)

      return response.status
    } catch (err) {
      Sentry.captureMessage('Error editing user profile.', {
        level: 'error'
      })
      if (err && err.response && err.response.data && err.response.data.data) return err.response.data.data
    }
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/user.js